import React from "react";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const ChartOfAccountActionButton = ({
  id,
  setEdit,
  setChartOfAccountId,
  toggleShowAddEditChartOfAccount,
  toggleShowDelete
}) => {
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={() => {
                setEdit(true);
                toggleShowAddEditChartOfAccount();
                setChartOfAccountId(id);
              }}
            />
          </span>
        </CustomTooltip>
        <span>/</span>
        <CustomTooltip message={"Delete"}>
          <span>
            <FontAwesomeIcon
              icon={faTrash}
              size="1x"
              onClick={() => {
                setChartOfAccountId(id);
                toggleShowDelete();
              }}
            />
          </span>
        </CustomTooltip>
      </span>
    </>
  );
};

export default ChartOfAccountActionButton;
